import styled from 'styled-components'

const Container = styled.div<{ index: number }>`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Text = styled.div`
  color: var(--color-text-error);
  font-size: 16px;
`

export { Container, Text }
